const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

export const extractAppResources = (payload) => {
  if (!isObject(payload)) {
    return null;
  }

  if (isObject(payload.app_resources)) {
    return payload.app_resources;
  }

  return payload;
};

export const extractAppResourcesMetadata = (payload) => {
  const resources = extractAppResources(payload);
  return isObject(resources?.metadata) ? resources.metadata : null;
};

export const extractRewardClaimTokens = (payload) => {
  const metadata = extractAppResourcesMetadata(payload);
  return Array.isArray(metadata?.reward_claim_tokens)
    ? metadata.reward_claim_tokens
    : [];
};

export const extractGettonciniResource = (payload) => {
  const resources = extractAppResources(payload);
  return isObject(resources?.gettoncini) ? resources.gettoncini : null;
};

export const extractStreakResource = (payload) => {
  const resources = extractAppResources(payload);
  return isObject(resources?.streak) ? resources.streak : null;
};

export const extractLearnedTermsResource = (payload) => {
  const resources = extractAppResources(payload);
  if (isObject(resources?.learned_terms)) {
    return resources.learned_terms;
  }

  const legacyLearningProgress = isObject(payload?.learning_progress)
    ? payload.learning_progress
    : null;

  if (!legacyLearningProgress) {
    return null;
  }

  return {
    count: legacyLearningProgress.learned_terms_count ?? null,
    delta: legacyLearningProgress.learned_terms_delta ?? 0,
    message: legacyLearningProgress.message ?? null,
  };
};

export const extractStellineResource = (payload) => {
  const resources = extractAppResources(payload);
  return isObject(resources?.stelline) ? resources.stelline : null;
};
